import React, { useState, useEffect, Suspense, lazy } from "react";
import Banner from "./components/js/Banner";
import "./components/css/common.css";
import "./components/css/variables.css";
import { Loader } from "./components/js/Loader";
import axios from "axios";
import { getSortedJsonWrtDates } from "./components/js/helpers";
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider";
const Videos = lazy(() => import("./components/js/Videos"));
const Info = lazy(() => import("./components/js/Info"));
const PressRelease = lazy(() => import("./components/js/PressRelease"));
const BestOfYoutube = lazy(() => import("./components/js/BestOfYoutube"));
// const SocialMedia = lazy(() => import("./components/js/SocialMedia"));
const ScrollToTop = lazy(() => import("./components/js/ScrollToTop"));
const Footer = lazy(() => import("./components/js/Footer"));
const Navbar = lazy(() => import("./components/js/Navbar"));
function App() {
  const [deviceType, setDeviceType] = useState(
    window.innerWidth < 575 ? "mobile" : "desktop"
  );
  const [pressReleaseList, setPressReleaseList] = useState([]);

  const [angelAiLink, setAngelAiLink] = useState('');
  const [angelComLink, setAngelComLink] = useState('');
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink2, setSunwestLink2] = useState("");
  const [sunwestLink3, setSunwestLink3] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();


  useEffect(() => {
     const processContent = async () => {
      const swLink = await getHyperLink('websites', 'swmc', 1);
      const swLink2 = await getHyperLink('websites','swmc',4);
      const swLink3 = await getHyperLink('websites','swmc',0);
      const aiLink = await getHyperLink('websites', 'angelai', 0);
      const aiComLink = await getHyperLink('websites','angelai',1);
      const cellLink = await getHyperLink('websites', 'celligence', 1);
      const celliLlcLink = await getHyperLink('websites', 'celligence', 0);
      const pavan = await getHyperLink('profiles', 'pavan', 0);
      setAngelAiLink(aiLink || 'AngelAi');
      setAngelComLink(aiComLink || 'AngelAi.com');
      setSunWestLink(swLink || 'Sun West Mortgage Company, Inc.');
      setSunwestLink2(swLink2 || "Sun West Mortgage Company");
      setSunwestLink3(swLink3 || 'Sun West');
      setCelligenceLink(cellLink || 'Celligence');
      setCelligenceLlcLink(celliLlcLink || 'Celligence LLC');
      setPavanLink(pavan || 'Pavan Agarwal');
     };
     processContent();
  }, [getHyperLink])


 
  useEffect(() => {
    window.addEventListener("resize", () => {
      setDeviceType(window.innerWidth < 575 ? "mobile" : "desktop");
    });

    window.scrollTo(0, 0);

    if (pressReleaseList.length === 0) {
      axios.get(`${process.env.REACT_APP_PRESS_RELEASES}?timestamp=${Date.now()}`).then((res) => {
        const arrayWithLatestDates = getSortedJsonWrtDates(res.data);
        setPressReleaseList(arrayWithLatestDates);
      });
    }

    return () => {
      window.removeEventListener("resize", () => {});
    };
  }, []);
  
  return (
    <div className="pavans-page">
      <Suspense fallback={<Loader />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Banner sunwestLink2={sunwestLink2} celligenceLlcLink={celligenceLlcLink} pavanLink={pavanLink} angelAiLink={angelAiLink} />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Info  sunwestLink={sunwestLink} sunwestLink2={sunwestLink2} sunwestLink3={sunwestLink3} celligenceLlcLink={celligenceLlcLink} angelAiLink={angelAiLink} celligenceLink={celligenceLink} pavanLink={pavanLink}/>
      </Suspense>
      <Suspense fallback={<Loader />}>
        <PressRelease
          deviceType={deviceType}
          pressReleaseList={pressReleaseList}
          pressReleaseTitle="Press Release"
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Videos deviceType={deviceType} />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <BestOfYoutube deviceType={deviceType} />
      </Suspense>
      {/* Hidden until the Social Media section is updated
      <Suspense fallback={<Loader />}>
        <SocialMedia deviceType={deviceType} />
      </Suspense>
      */}
      <Suspense fallback={<div />}>
        <ScrollToTop />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Footer deviceType={deviceType} angelAiLink={angelAiLink} sunwestLink={sunwestLink3} celligenceLlcLink={celligenceLlcLink} />
      </Suspense>
      <CookieSetting 
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </div>
  );
}
export default App;
